import React from 'react';
import { Card, CardContent } from '../../../components/ui/card';
import { Switch } from '../../../components/ui/switch';


const CheckPermission = ({ label, description, checked, checkboxCheck }) => {
    return (
        <Card>
            <CardContent className="flex">
                {/* <ToggleButton
                    isActive={checked}
                    handleToggle={() => checkboxCheck(!checked)}
                /> */}
                <Switch
                    checked={checked}
                    onCheckedChange={() => checkboxCheck(!checked)}
                    className="transition-all"
                />
                <div className='flex flex-col ml-2'>
                    <label
                        htmlFor={label}
                        onClick={() => checkboxCheck(!checked)}
                        className="text-sm font-medium text-secondary-foreground font-bold leading-none cursor-pointer peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                        {label}
                    </label>
                    <p className='text-xs font-medium text-muted-foreground mt-2'>{description || ""}</p>
                </div>
            </CardContent>
        </Card>
    );
};

export default CheckPermission;
